export default "__VITE_ASSET__CeGo8F2c__"